import { Html5Qrcode } from "html5-qrcode";
import React from 'react';
import I18n from "../../localization";


const qrcodeRegionId = "html5qr-code-full-region";

class QrCodeScannerPlugin extends React.Component {

  constructor(props) {
    super(props);
    this.html5QrCode = null
  }

    render() {
        return <div id={qrcodeRegionId} />;
    }

    componentWillUnmount() {
      this.stopScanning();
    }

    componentDidMount() {
        // Creates the configuration object for Html5QrcodeScanner.
        function createConfig(props) {
            var config = {};
            if (props.fps) {
            config.fps = props.fps;
            }
            if (props.qrbox) {
            config.qrbox = props.qrbox;
            }
            if (props.aspectRatio) {
            config.aspectRatio = props.aspectRatio;
            }
            if (props.disableFlip !== undefined) {
            config.disableFlip = props.disableFlip;
            }
            return config;
        }

        var config = createConfig(this.props);
        var verbose = this.props.verbose === true;

        // Suceess callback is required.
        if (!(this.props.qrCodeSuccessCallback )) {
            throw I18n.t('mobile.component.qrCodeSuccessCallback');
        }

        Html5Qrcode.getCameras().then(devices => {
            /**
             * devices would be an array of objects of type:
             * { id: "id", label: "label" }
             */
             this.html5QrCode = new Html5Qrcode(/* element id */ "reader");
             const qrCodeSuccessCallback = (decodedText, decodedResult) => {
              var separateLines = decodedText.match(/[^\r\n]+/g);
                
                  if(separateLines[0].match('([0-9]{2})?')){
                    this.props.qrCodeSuccessCallback(separateLines[0], decodedResult);
                    this.html5QrCode.stop().then((ignore) => {
                      // QR Code scanning is stopped...
                    }).catch((err) => {
                      // Stop failed, handle it...
                    });
                  }
            };
            if (devices && devices.length) {
              var cameraId = devices[0].id;
              // .. use this to start scanning.
                this.html5QrCode.start(
                { facingMode: "environment" }, 
                {
                    fps: 10,    // Optional, frame per seconds for qr code scanning
                    qrbox: { width: 250, height: 250 }  // Optional, if you want bounded box UI
                },
                qrCodeSuccessCallback,
                this.props.qrCodeErrorCallback)
                .catch((err) => {
                // Start failed, handle it.
                });
            } else {
              console.log("Couldn't find any camera devices");
            }
          }).catch(err => {
            console.error('Exception',err)
          });
    }
    

    stopScanning(){
      //debugger
        //const html5QrCode = new Html5Qrcode(/* element id */ "reader");
        //html5QrCode.clear();
        // html5QrCode.pause()
        if(this.html5QrCode && this.html5QrCode.isScanning){
            this.html5QrCode.stop().then((ignore) => {
                // QR Code scanning is stopped...
              }).catch((err) => {
                // Stop failed, handle it...
              });
        } 
    }

     clear() {
      debugger
      const emptyHtmlContainer = () => {
          const mainContainer = document.getElementById("reader");
          if (mainContainer) {
              mainContainer.innerHTML = "";
              mainContainer.style.border = "none";
          }
      }
      //const html5QrCode = new Html5Qrcode(/* element id */ "reader");
      if (this.html5QrCode) {
              if (this.html5QrCode.isScanning) {
                  this.html5QrCode.stop().then((_) => {
                      this.html5QrCode.clear();
                      emptyHtmlContainer();
                  })
              } else {
                  // Assuming file based scan was ongoing.
                  this.html5QrCode.clear();
                  emptyHtmlContainer();
              }
        
      }
  }



};

export default QrCodeScannerPlugin;